import { FC } from 'react'
import { ReactComponent as EditIcon } from 'src/assets/svg/edit-2.svg'
import { TruncatedTooltip } from 'src/components/TruncatedTooltip'
import { CampaignStatsTopKeyword } from 'src/services/__generated__/api'
import styles from './totalSourcesCard.module.scss'

interface TotalSourcesCardProps {
  hasData?: boolean
  topKeywords?: CampaignStatsTopKeyword[]
}

export const TotalSourcesCard: FC<TotalSourcesCardProps> = ({
  hasData = false,
  topKeywords = [],
}) => {
  const col1 = topKeywords.slice(0, 3)
  const col2 = topKeywords.slice(3, 6)

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <EditIcon className={styles.icon} />
        <h3 className={styles.title}>Top Keywords</h3>
        <span className={styles.subtitle}>by Mentions</span>
      </div>
      {hasData && topKeywords.length > 0 ? (
        <div className={styles.grid}>
          <div className={styles.column}>
            {col1.map((kw, i) => (
              <div className={styles.item} key={i}>
                <span className={styles.dot} />
                <TruncatedTooltip
                  className={styles.label}
                  text={kw.keyword ?? ''}
                />
              </div>
            ))}
          </div>
          <div className={styles.column}>
            {col2.map((kw, i) => (
              <div className={styles.item} key={i}>
                <span className={styles.dot} />
                <TruncatedTooltip
                  className={styles.label}
                  text={kw.keyword ?? ''}
                />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.noData}>No Data</div>
      )}
    </div>
  )
}
